import request from '../utils/request';

// 分页查询陪逛服务提供者申请
export const listAccompanyShoppingProviderApplications = (params) => {
  return request({
    url: '/accompany-shopping-provider-application/list',
    method: 'get',
    params
  });
};

// 查询单个陪逛服务提供者申请详情
export const getAccompanyShoppingProviderApplicationById = (id) => {
  return request({
    url: `/accompany-shopping-provider-application/${id}`,
    method: 'get'
  });
};

// 批量更新陪逛服务提供者申请状态
export const updateProviderApplicationsStatus = (applicationIds, status) => {
  return request({
    url: '/accompany-shopping-provider-application/status',
    method: 'put',
    data: applicationIds,
    params: { status }
  });
};

// 审核陪逛服务提供者申请
export const reviewProviderApplication = (data) => {
  return request({
    url: '/accompany-shopping-provider-application/review',
    method: 'put',
    params: data
  });
};

// 更新陪逛服务提供者申请信息
export const updateAccompanyShoppingProviderApplication = (applicationData) => {
  return request({
    url: '/accompany-shopping-provider-application/update',
    method: 'put',
    data: applicationData
  });
};
